module.exports = __webpack_public_path__ + "static/carpool-gallery-11-83fac2b6e5f8815484666aee9eef9cfc.jpg";